import React from "react";
import { Button, Modal } from "react-bootstrap";
import ReactToPrint from "react-to-print";

const AppModal = ({
  className,
  showHeader = true,
  showFooter = true,
  showCancelBtn = true,
  showSubmitBtn = true,

  Title,
  title,
  children,
  cancelBtnText,
  submitBtnText,

  visible,
  handleClose,

  onSubmit,
  disableSubmit = false,
  disableCancel = false,
  disableBtns = false,
  backdrop = "static",
  modalProps = {},

  enablePrinting = false,
}) => {
  const componentRef = React.useRef(null);

  const printData = (
    <div style={{ margin: "0.2rem" }} ref={componentRef}>
      <div style={{ margin: "1rem 1rem 0 1rem" }}>
        <Modal.Title>{Title ? <Title /> : title}</Modal.Title>
      </div>
      <Modal.Body>{children}</Modal.Body>
    </div>
  );

  return (
    <Modal
      show={visible}
      onHide={handleClose}
      className={className || "app-modal"}
      backdrop={backdrop}
      {...modalProps}
    >
      {showHeader ? (
        <Modal.Header closeButton>
          <Modal.Title>{Title ? <Title /> : title}</Modal.Title>
        </Modal.Header>
      ) : null}
      <Modal.Body>
        <>
          <ReactToPrint
            content={() => componentRef.current}
            // onAfterPrint={this.handleAfterPrint}
            // onBeforeGetContent={this.handleOnBeforeGetContent}
            // onBeforePrint={this.handleBeforePrint}
            removeAfterPrint
            trigger={() => (
              <div>
                {enablePrinting ? (
                  <div className="printbutton">Print</div>
                ) : null}
              </div>
            )}
          />

          <div>{children}</div>
          <div style={{ display: "none" }}>{printData}</div>
        </>
      </Modal.Body>
      {showFooter ? (
        <Modal.Footer>
          {showCancelBtn ? (
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={disableBtns || disableCancel}
            >
              {cancelBtnText || "Cancel"}
            </Button>
          ) : null}
          {showSubmitBtn ? (
            <Button
              variant="primary"
              onClick={onSubmit}
              disabled={disableBtns || disableSubmit}
            >
              {submitBtnText || "Submit"}
            </Button>
          ) : null}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

export default AppModal;
